import { css } from '@emotion/css';
import { theme, sizes } from 'Shared/frontend/SettingsProvider';
import { Component } from 'Shared/frontend/widgets/Component';
import { ChildKeyContext } from 'Shared/frontend/widgets/StylesProvider';
import { onCleanup, onMount, Show, createSignal, Switch, Match } from 'solid-js';
import { usePreviewContainer } from 'Shared/frontend/PreviewProvider';

const wide = () => theme().widgets.visualWithInfo.wide;
const narrow = () =>  theme().widgets.visualWithInfo.narrow;

const floatStyle = (side:string) => css({
	float: side,
    width: wide().float.width,
	/* Hacky way of roughly aligning top of float to top of title. Hard to do better though. */
    paddingTop: wide().float.paddingTop,

	paddingLeft: side=='left' ? wide().float.outerPadding : wide().float.innerPadding,
	paddingRight: side=='right' ? wide().float.outerPadding : wide().float.innerPadding,

	marginLeft: side=='left' ? wide().float.outerMargin : wide().float.innerMargin,
	marginRight: side=='right' ? wide().float.outerMargin : wide().float.innerMargin
});

const wideStyle = () => css({
	textAlign: wide().textAlign
});

const narrowStyle = () => css({
	textAlign: narrow().textAlign
});

const narrowVisualStyle = () => css({
	margin: '1em 0',
});



export function VisualWithInfo(P)
{
	/* For Web browser lets deliver desktop view: */
	const [wide,setWide] = createSignal(true);

	const sz = sizes();

	onMount(() => {
		const container = usePreviewContainer()?.() ?? document.documentElement;

		/* 
			Shrinking to one column clunks on FF at the moment. Chrome seems OK. Doesn't look like a Solid issue. 
			Using debounce to ease the transition. 
		*/
		let timer: ReturnType<typeof setTimeout>;

		const resizeObserver = new ResizeObserver(() => {
			clearTimeout(timer);
			timer = setTimeout(() => setWide(container.clientWidth >= sz.flipToOneColumn), 30);
		});
		resizeObserver.observe(container);

		onCleanup(() => {
			clearTimeout(timer);
			resizeObserver.unobserve(container);
		});
	});

	return (
		<Switch>
			<Match when={wide()}>
				<WideVersion {...P} />
			</Match>
			<Match when={true}>
				<NarrowVersion {...P} />
			</Match>
		</Switch>
	);
}

function WideVersion(P)
{
	return (
		<div class={css(wideStyle(),P.styling.css ?? {})}>
			<Show when={P.visual}>
				<div class={floatStyle(P.visualPosition)}>
					<ChildKeyContext.Provider value={() => 'visual'}>
						<Component {...P.visual} />
					</ChildKeyContext.Provider>
				</div>
			</Show>
			<Show when={P.upper}>
				<ChildKeyContext.Provider value={() => 'upper'}>
					<Component {...P.upper} />
				</ChildKeyContext.Provider>
			</Show>
			<Show when={P.lower}>
				<ChildKeyContext.Provider value={() => 'lower'}>
					<Component {...P.lower} />
				</ChildKeyContext.Provider>
			</Show>

			<div style='clear:both' />
		</div>
	);
}

function NarrowVersion(P)
{
	return (
		<div class={css(narrowStyle(),P.styling.css ?? {})}>
			<Show when={P.upper}>
				<ChildKeyContext.Provider value={() => 'upper'}>
					<Component {...P.upper} />
				</ChildKeyContext.Provider>
			</Show>
			<Show when={P.visual}>
				<div class={narrowVisualStyle()}>
					<ChildKeyContext.Provider value={() => 'visual'}>
						<Component {...P.visual} />
					</ChildKeyContext.Provider>
				</div>
			</Show>
			<Show when={P.lower}>
				<ChildKeyContext.Provider value={() => 'lower'}>
					<Component {...P.lower} />
				</ChildKeyContext.Provider>
			</Show>
		</div>
	);
}
